<!-- /* [NT-PF-READ-C-POP] 프로필보기(기업) */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="프로필 보기"
      v-if="data"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <CorpInfoCard :data="data" hide-company />

        <div>
          <h6 class="popupViewProfileHeadline">기업 정보</h6>
          <table class="popupViewProfileTable">
            <tbody>
              <tr>
                <td class="firstTd">업종</td>
                <td>
                  <template v-if="data.fieldType">
                    {{
                      this.lodash.find(objFieldType, function(o) {
                        return o.value == data.fieldType;
                      }).text
                    }}
                  </template>
                </td>
              </tr>
              <tr>
                <td class="firstTd">설립 연도</td>
                <td>{{ data.establishmentYear }}</td>
              </tr>
              <tr>
                <td class="firstTd">기업 형태</td>
                <td>
                  <template v-if="data.companyType">
                    {{
                      this.lodash.find(objCompanyType, function(o) {
                        return o.value == data.companyType;
                      }).text
                    }}
                  </template>
                </td>
              </tr>
              <tr>
                <td class="firstTd">사원수</td>
                <td>{{ data.memberSize }}</td>
              </tr>
              <tr>
                <td class="firstTd">매출 규모</td>
                <td>{{ data.profitSize }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">제품(서비스)</h6>
          <template v-if="data.productServiceDesc">
            <table class="popupViewProfileTable">
              <tbody>
                <tr>
                  <td class="firstTd">제품(서비스)명</td>
                  <td>{{ data.productServiceName }}</td>
                </tr>
                <tr>
                  <td class="firstTd">제품(서비스) 설명</td>
                  <td>
                    {{ data.productServiceDesc }}
                  </td>
                </tr>
              </tbody>
            </table>
          </template>

          <template v-else>
            <table
              v-for="(item, index) in productServices"
              class="popupViewProfileTable"
              :style="index > 0 ? 'margin-top: 12px;' : ''"
              :key="index"
            >
              <tbody>
                <tr>
                  <td rowspan="2" class="headlineTd">{{ index + 1 }}</td>
                  <td class="firstTd">제품(서비스)명</td>
                  <td>{{ item.productServiceName }}</td>
                </tr>
                <tr>
                  <td class="firstTd">제품(서비스) 설명</td>
                  <td>
                    <div>{{ item.productServiceDesc }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">나의 비즈니스</h6>
          <table
            v-for="(item, index) in industries1"
            class="popupViewProfileTable"
            :style="index > 0 ? 'margin-top: 12px;' : ''"
            :key="index"
          >
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">{{ index + 1 }}</td>
                <td class="firstTd">산업</td>
                <td>{{ item.text }}</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>
                  <div v-for="(subItem, index2) in item.sub" :key="index2">
                    <span v-if="typeof subItem === 'object'">{{ subItem.text }}</span>
                    <span v-else>{{ subItem }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망분야</h6>
          <table
            v-for="(item, index) in industries2"
            class="popupViewProfileTable"
            :style="index > 0 ? 'margin-top: 12px;' : ''"
            :key="index"
          >
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">{{ index + 1 }}</td>
                <td class="firstTd">산업</td>
                <td>{{ item.text }}</td>
              </tr>
              <tr>
                <td class="firstTd">세부 분야</td>
                <td>
                  <div v-for="(subItem, index2) in item.sub" :key="index2">
                    <span v-if="typeof subItem === 'object'">{{ subItem.text }}</span>
                    <span v-else>{{ subItem }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h6 class="popupViewProfileHeadline">매치메이킹 희망활동</h6>
          <table
            v-for="(item, index) in activities"
            :key="index"
            :style="index > 0 ? 'margin-top: 12px;' : ''"
            class="popupViewProfileTable"
          >
            <tbody>
              <tr>
                <td rowspan="2" class="headlineTd">{{ index + 1 }}</td>
                <td class="firstTd">희망 분야</td>
                <td>{{ item.text }}</td>
              </tr>
              <tr>
                <td class="firstTd">세부 내용</td>
                <td>{{ item.content }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template #footer>
        <div style="display: flex; align-items: center; gap: 1rem;">
          <template v-if="user.roleName == 'ROLE_ADMIN'">
            <MainButton
              btnText="닫기"
              width="191px"
              color="gray"
              fontSize="2rem"
              customHeight="53px"
              @click="handleToggleModal"
            />
          </template>
          <template v-else>
            <MainButton
              btnText="네트워킹 신청 하기"
              customHeight="53px"
              fontSize="2rem"
              @click="handleOk(data)"
            />
            <button
              style="border: 1px solid #989898; background-color: #fff; height: 53px; width: 191px;  font-size: 2rem;"
              @click="handleToggleModal"
            >
              닫기
            </button>
          </template>
        </div>
      </template>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { hopeActivity, ageFriendlyIndustry, relevantList } from "@/data/constances";
import { fieldType, companyType } from "@/utils/corpUtil";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";

export default {
  name: "ViewProfileCompany",
  components: { BasicModal, MainButton, CorpInfoCard },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    handleOk: Function,
    data: Object,
  },
  computed: {
    industries1() {
      if (
        this.data?.industries1 == "null" ||
        this.lodash.isEmpty(this.data?.industries1)
      )
        return [];
      let item = JSON.parse(this.data?.industries1);
      return (
        item
          .map((item) => {
            let obj = ageFriendlyIndustry.find(
              (temp) => temp.value == item.categoryIndustryId,
            );
            if (!obj) return null;

            let sub = item.categoryIds
              .map((subItem) => {
                let tmp = obj.sectors.find((a) => a.value == subItem);
                return tmp !== undefined ? tmp : subItem;  // tmp가 undefined이면 subItem 반환
              })
              ?.filter((e) => e != null);
            return {
              ...item,
              sub,
              text: obj.name,
            };
          })
          ?.filter((item) => item !== null) || []
      );
    },
    industries2() {
      if (
        this.data?.industries2 == "null" ||
        this.lodash.isEmpty(this.data?.industries2)
      )
        return [];
      let item = JSON.parse(this.data?.industries2);
      return (
        item
          .map((item) => {
            let obj = ageFriendlyIndustry.find(
              (temp) => temp.value == item.categoryIndustryId,
            );
            if (!obj) return null;

            let sub = item.categoryIds
              .map((subItem) => {
                let tmp = obj.sectors.find((a) => a.value == subItem);
                return tmp !== undefined ? tmp : subItem;  // tmp가 undefined이면 subItem 반환
              })
              ?.filter((e) => e != null);
            return {
              ...item,
              sub,
              text: obj.name,
            };
          })
          ?.filter((item) => item !== null) || []
      );
    },
    productServices() {
      if (
        this.data?.productServiceName == "null" ||
        this.lodash.isEmpty(this.data?.productServiceName)
      )
        return [];
      let item = JSON.parse(this.data?.productServiceName);
      return (
        item
          .map((productService) => {
            return {
              productServiceName: productService.name,
              productServiceDesc: productService.desc
            };
          })
          ?.filter((item) => item !== null) || []
      );
    },
    activities() {
      if (
        this.data?.activities == "null" ||
        this.lodash.isEmpty(this.data?.activities)
      )
        return [];
      let item = JSON.parse(this.data?.activities);
      return (
        item
          .map((activity) => {
            let item = hopeActivity.find((a) => a.value == activity.activityId);
            if (!item) return null;
            return {
              ...activity,
              text: item.name,
            };
          })
          ?.filter((item) => item !== null) || []
      );
    },
  },
  data() {
    return {
      user: this.$store.state.auth.user,
      objFieldType: fieldType,
      objCompanyType: companyType,
    };
  },
  methods: {
    // onClickSubmitForm() { }
    gotoHome(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped></style>
